// extracted by mini-css-extract-plugin
export default {"dangerMessage":"DangerMessage_dangerMessage__niJsu"};